import React from 'react';
import PropTypes from 'prop-types';

const CategorySvg = ({ color, width, height }) => {
  return (
    <svg
      width={`${width || 21}`}
      height={`${height || 20}`}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M14.7363 8.33335H16.403C18.0697 8.33335 18.903 7.50002 18.903 5.83335V4.16669C18.903 2.50002 18.0697 1.66669 16.403 1.66669H14.7363C13.0697 1.66669 12.2363 2.50002 12.2363 4.16669V5.83335C12.2363 7.50002 13.0697 8.33335 14.7363 8.33335Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.73633 18.3334H6.40299C8.06966 18.3334 8.90299 17.5 8.90299 15.8334V14.1667C8.90299 12.5 8.06966 11.6667 6.40299 11.6667H4.73633C3.06966 11.6667 2.23633 12.5 2.23633 14.1667V15.8334C2.23633 17.5 3.06966 18.3334 4.73633 18.3334Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.56966 8.33335C7.41061 8.33335 8.90299 6.84097 8.90299 5.00002C8.90299 3.15907 7.41061 1.66669 5.56966 1.66669C3.72871 1.66669 2.23633 3.15907 2.23633 5.00002C2.23633 6.84097 3.72871 8.33335 5.56966 8.33335Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5697 18.3334C17.4106 18.3334 18.903 16.841 18.903 15C18.903 13.1591 17.4106 11.6667 15.5697 11.6667C13.7287 11.6667 12.2363 13.1591 12.2363 15C12.2363 16.841 13.7287 18.3334 15.5697 18.3334Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

CategorySvg.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default CategorySvg;
